import {StopPlaySvc} from '../services/StopPlaySvc';
import {Observer} from '../services/ViewPortSvc';

export class ScrollButton {
    canAnimate = true;
    private stopPlaySvc: StopPlaySvc;

    constructor(private $element: ng.IAugmentedJQuery,
                private $rootScope: ng.IRootScopeService,
                private ViewPortSvc: Observer) {
        this.stopPlaySvc = new StopPlaySvc(
            $rootScope,
            ViewPortSvc,
            $element,
            canAnimate => this.canAnimate = canAnimate
        );
    }
}

angular.module('animatronApp.scrollButton', []).component('scrollButton', {
    controller: ScrollButton,
    template: '<span class="scroll-button" ng-class="{animate: $ctrl.canAnimate}">{{::$root.t("wv.landing.top.smmw.scroll")}}</span>'
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/scrollButton.ts